import { BaseDivider } from "@/shared/ui/base-divider";
import { SidebarListItem } from "@/widgets/sidebar/ui/sidebar-list-item";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useState } from "react";

type Props = {
  currentPath: string;
  companyId: number;
};

export const SystemAdminItems = ({ currentPath, companyId }: Props) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <BaseDivider />

      <List>
        <ListItem sx={{ px: 2 }}>
          <ListItemButton
            onClick={handleClick}
            disableRipple
            draggable={false}
            sx={{
              border: "1px solid",
              borderColor: "transparent",
              borderRadius: "16px",
              fontWeight: 700,
              "&:hover": {
                backgroundColor: "#E1F5EF",
              },
              "&:active": {
                backgroundColor: "transparent",
              },
              "& MuiTypography-root": {
                fontWeight: 700,
              },
            }}
          >
            <ListItemIcon color="primary">
              <SupervisorAccountIcon />
            </ListItemIcon>
            <ListItemText
              primary="管理者向け"
              primaryTypographyProps={{
                sx: {
                  fontWeight: 700,
                  color: "grey.500",
                  fontSize: "16px",
                },
              }}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>

        <Collapse in={open}>
          <SidebarListItem
            href={`/companies/${companyId}`}
            text="会社詳細"
            icon="building"
            isActive={currentPath === `/companies/${companyId}`}
          />
        </Collapse>
      </List>
    </>
  );
};
